export default __webpack_public_path__ + "static/media/food-ingredient.07d2a583.png";